<section class="cue-section cue-section--send">
	<span class="cue-step-label">2. Qué se enviará</span>
	<h4>Actividades preparadas para el CUE</h4>

	@if (hasPreparedActivities) {
		<div class="cue-send-list" aria-label="Actividades que se enviarán">
			@for (item of preparedItems; track item.label) {
				<div class="cue-send-item">
					<i [class]="item.icon" aria-hidden="true"></i>
					<div>
						<strong>{{ item.count }}</strong>
						<span>{{ item.label }}</span>
					</div>
				</div>
			}
		</div>

		<p class="muted">No se enviarán las actividades que tengan errores antes de preparar el cuaderno.</p>
	} @else {
		<p class="cue-empty-state">No hay actividades pendientes de envío.</p>
	}
</section>
